var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isDisplay
    ? _c(
        "div",
        {
          staticClass: "render-item",
          class: {
            italic: _vm.italic == "all",
            strong: _vm.strong == "all"
          },
          style: {
            fontWeight: _vm.strong,
            lineHeight: _vm.lineHeight
          }
        },
        [
          _c("div", { staticClass: "render-line" }, [
            _c(
              "span",
              {
                class: {
                  italic: _vm.italic == "label",
                  strong: _vm.strong == "label"
                }
              },
              [_vm._v(_vm._s(_vm.lineText))]
            ),
            _vm._v(" "),
            _c("span", {
              staticClass: "line",
              style: { borderStyle: _vm.lineStyle }
            })
          ])
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a62f6d7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a62f6d7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/render_item/RenderReal.vue
// module id = null
// module chunks = 